import { createAction, props } from '@ngrx/store';
import { Orders } from './orders.interface';

/**
 * Called from order lookup flow
 * when GuestOrderSearch returns successful with Orders
 */
export const routeToOrdersAction = createAction(
	'[Orders] GetOrderSearch Success with Orders',
	props<{ payload: Orders }>()
);

export const clearOrdersAction = createAction('[Orders] Clear Orders from Recover State');
